export default "__VITE_ASSET__4326496d__"